import { baseRequest } from "../axiosconfig";

// Izvlači ime fajla iz Content-Disposition zaglavlja (podržava filename*=UTF-8'')
function filenameFromHeaders(headers, fallbackName) {
  const disposition = headers?.["content-disposition"] || "";
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch (e) {
      // fallback ispod
    }
  }
  const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
  if (plainMatch) return plainMatch[1];
  return fallbackName;
}

/**
 * Preuzima fajl sa backend endpointa (XLSX/DOCX/JSON) i pokreće download u
 * browseru. Greške (401/422/500) stižu kao blob — dekodiraju se u poruku.
 */
export async function downloadFile(url, fallbackName = "izvoz", options = {}) {
  const { errorMessage = "Izvoz nije uspeo." } = options;
  try {
    const res = await baseRequest.get(url, { responseType: "blob" });
    const filename = filenameFromHeaders(res.headers, fallbackName);

    const objectUrl = URL.createObjectURL(res.data);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
    return true;
  } catch (err) {
    let message = errorMessage;
    if (err.response?.status === 403) {
      // Umesto sirove poruke servera („Forbidden.“) — tekst koji aplikacija već koristi
      message = "Nemate ovlašćenje za ovu akciju.";
    } else if (err.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text();
        const parsed = JSON.parse(text);
        if (parsed.message) message = parsed.message;
      } catch (e) {
        // zadrži podrazumevanu poruku
      }
    }
    alert(message);
    return false;
  }
}
